/**
 * TanStack Router: /meetings/schedule
 *
 * This route file was auto-generated by the route generation script.
 * Component: MeetingsSchedulePage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import MeetingsSchedulePage from '@/app/meetings/schedule/page'

/**
 * Route: /meetings/schedule
 * Layout: _auth (authenticated)
 * Component: MeetingsSchedulePage
 */
export const Route = createFileRoute('/_auth/meetings/schedule')({
  component: MeetingsSchedulePage,
})
